import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=bd2d0ed4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/payment.css?vue&type=style&index=0&id=bd2d0ed4&prod&scoped=true&lang=css&external"
import style1 from "./Home.vue?vue&type=style&index=1&id=bd2d0ed4&prod&scoped=true&lang=css"
import style2 from "./Home.vue?vue&type=style&index=2&id=bd2d0ed4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2d0ed4",
  null
  
)

export default component.exports